import { normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-516431c7"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["alt"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_lazy = _resolveDirective("lazy");
  return _openBlock(), _createElementBlock("div", {
    class: "transition-image",
    onMouseenter: _cache[1] || (_cache[1] = (...args) => $options.restartTrasition && $options.restartTrasition(...args)),
    onMouseout: _cache[2] || (_cache[2] = (...args) => $options.stopTransition && $options.stopTransition(...args))
  }, [_withDirectives(_createElementVNode("img", {
    class: "transition-image-item",
    style: _normalizeStyle($options.transitionStyle),
    alt: $props.picObj.alt,
    onLoad: _cache[0] || (_cache[0] = $event => $options.handleLoad($event))
  }, null, 44, _hoisted_1), [[_directive_lazy, 'https://cdn.static.linkr.bio/static/linkr/home/' + $props.picObj.src]])], 32);
}